import PropTypes from 'prop-types';
import React from 'react';
import { generatePath, Navigate, Outlet, useParams } from 'react-router-dom';

import Loading from 'common/components/Loading';
import useConfig from 'common/hooks/useConfig';

// Layout route gating its child routes on an event config. While the config is
// loading we can't yet tell enabled from disabled, so hold rendering to avoid
// redirecting users who do have the feature; once loaded, disabled events are
// sent back to the event home.
const EventConfigGatedRoute = ({ configKey }) => {
  const config = useConfig();
  const { organizationId, eventId } = useParams();

  if (config.loading) {
    return <Loading />;
  }

  if (!config.isConfigEnabled(configKey)) {
    return (
      <Navigate
        to={generatePath('/organization/:organizationId/event/:eventId', {
          organizationId,
          eventId,
        })}
        replace
      />
    );
  }

  return <Outlet />;
};

EventConfigGatedRoute.propTypes = {
  configKey: PropTypes.string.isRequired,
};

export default EventConfigGatedRoute;
